import {axiosIns} from 'config/api.config'
import {ENV} from 'config/ENV.config'

/**
 * Favorites (saved page shortcuts) live in sso-service (`public.shortcut_link`).
 * Call them through the SSO gateway, reusing axiosIns so the auth headers/interceptors apply.
 */
export const FavoriteService = {
  list: async (): Promise<any> => await axiosIns.get('/shortcut-link/my', {baseURL: ENV.ssoGetway}),

  add: async (payload: {name: string; path: string; icon?: string}): Promise<any> =>
    await axiosIns.post('/shortcut-link/save', payload, {baseURL: ENV.ssoGetway}),

  remove: async (id: string): Promise<any> =>
    await axiosIns.delete('/shortcut-link/delete', {data: {id}, baseURL: ENV.ssoGetway}),
}
